import { THEME } from '@/constants/common'

export const GOAL_EVENT_TYPE = {
  CHECKIN: 'checkin',
  COMMENT: 'comment',
  KR_CREATED: 'kr_created',
  KR_EDITED: 'kr_edited',
  CREATED: 'created',
  AWARD: 'award',
  CLOSED: 'closed',
  REOPENED: 'reopened',
  OWNERSHIP_CHANGED: 'ownership_changed',
  FIELD_CHANGED: 'field_changed'
}

export const GOAL_ROW = 'GoalViewer'

// These are events of Goal shown in Activity Section on Goal Page

export const GOAL_ACTIVITY_EVENTS = [
  GOAL_EVENT_TYPE.CREATED,
  GOAL_EVENT_TYPE.COMMENT,
  GOAL_EVENT_TYPE.FIELD_CHANGED,
  GOAL_EVENT_TYPE.OWNERSHIP_CHANGED
]

export const GOAL_ICON_MAP = {
  [THEME.SUCCESS]: 'goal-on-track-icon',
  [THEME.WARNING]: 'goal-behind-icon',
  [THEME.DANGER]: 'goal-at-risk-icon',
  [THEME.DARK]: 'goal-icon-greyed'
}

export const FLEXIBLE_WEIGHTAGE = -1

export const TEMPLATE_TYPE = {
  PRE_GENERATED: 'PRE_GENERATED',
  AI: 'AI'
}
